<div class="flex h-screen w-screen flex-col items-center justify-center overflow-hidden bg-verde">
  <div class="mb-[30px]">
    <ln-no-found-svg-icon [class]="'w-[358px] h-[254px]'"></ln-no-found-svg-icon>
  </div>

  <div class="font-['Roboto'] text-8xl font-bold text-white">404</div>
  <div class="w-[337px] mt-[8px] font-['Roboto'] text-xl font-semibold leading-normal text-white">{{'messages.pageNotFound' | transloco}}</div>
  <div class="w-[333px] mt-[12px] sm:mt-[12px] sm:w-[439px] text-center font-['Roboto'] text-lg font-normal leading-normal text-white">
    {{'messages.pageHaveBeenDeleted' | transloco}}
  </div>
  <button (click)="goHome()" class="mt-[27px] sm:mt-[35px] h-12 w-40 rounded-md border border-white bg-white hover:bg-blanco hover:scale-105 hover:border-cafe cursor-pointer">
    <div class="text-base font-semibold leading-normal text-verde">{{'buttons.goBackToStart' | transloco}}</div>
  </button>

</div>
